import * as actionTypes from './actionTypes'

export const setIsDarkMode = (value) => {
    return {
        type: actionTypes.SET_IS_DARK_MODE,
        payload: {
            isDarkMode: value
        }
    }
}